import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
const getElementOffsetTop = (element) => {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  return element ? element.getBoundingClientRect().top + scrollTop : 0;
};
const useScrollToField = (fieldName, callback) => {
  const currentBreakpoint = MediaQuery.useBreakpoint();
  const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
  React.useEffect(() => {
    if (!fieldName) {
      return;
    }
    const headerOffset = isMobile ? 160 : 110;
    const element = document.getElementsByName(fieldName)?.[0] ?? null;
    if (!element) {
      return;
    }
    const top = getElementOffsetTop(element);
    window.scrollTo(0, top - headerOffset);
    callback && callback();
  }, [fieldName, isMobile, callback]);
};
export {
  useScrollToField
};
//# sourceMappingURL=use-scroll-to-field.js.map
